function camelToCapitalized(str: string) {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/^./, (char) => char.toUpperCase());
}

export default camelToCapitalized;